export default {
  methods: {
    async descargarExcel(servicio, id, opciones) {
      try {
        let response = null;

        if (id) {
          response = await servicio(id, opciones);
        } else {
          response = await servicio(opciones);
        }

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = this.getFilenameFromResponse(response) || `presupuestos_${Date.now()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'El archivo Excel se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'No se pudo descargar el archivo Excel.',
          type: 'error',
        });
      }
    },
    getFilenameFromResponse(response) {
      const contentDisposition = response.headers['content-disposition'];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

        if (filenameMatch && filenameMatch[1]) {
          return filenameMatch[1].replace(/['"]/g, '');
        }
      }

      return null;
    },
  },
};
